export const KycIncompleteBTemplate = {
    name: 'kyc_incomplete_2',
    label: 'KYC incomplete B',
    subject: "Get verified quickly and securely",
    category: 'reminders',
    body: "<p>Dear new Rebiter,</p>"
        + "<p>Your verification status needs attention!</p>"
        + "<ul>"
        + "<li>If you already received an SMS, then your verification link is about to expire. Head back to your AplyID SMS and follow the instructions.</li>"
        + "<li>Alternatively, log in to your <a href='https://my.rebitmoney.com/account/verification'>Verification tab</a>, send yourself a new text message,</li>"
        + "<li>Or switch to the Manual method which allows you to directly upload your ID and address proof.</li>"
        + "</ul>"
        + "<p style='margin-top: 25px;'>❓ Any questions? Simply reply to kyc@rebit.co.nz, or contact us via our <a href='https://my.rebitmoney.com/help-and-support/verification'>Help Centre</a>.</p>"
        + "<p style='margin-top: 25px; margin-bottom: 25px;'>The trusted and secure biometrics system we use to verify your identity deletes your data, minutes after the verification is completed. So, you can safely and efficiently get verified within a few minutes when you need to quickly send money to your loved ones. Read more on our <a href='https://my.rebitmoney.com/help-and-support/verification'>Help Centre</a>.</p>"
        + "<p>Happy Rebitting!</p>"
}

